/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useEffect, useRef, useState } from "react";
import volumeIcon from "../../Assets/volume_up.svg";
import { Loader } from "../../constents/components";
import arrow from "../../Assets/arrow.png";
import playIcon from '../../Assets/playIcon.svg';
import { MockInterviewContext } from '../../Contexts/mockInterviewContext';
import useRecordMock from '../../Hooks/mockInterview/useRecordMock';
import crossIcon from '../../Assets/close.svg';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


// forloading and error part

const Submiting = () => {

    return (
        <div className='flex items-center justify-start flex-col'>
            <h2 className='text-xl font-semibold'>We are fetching next question</h2>
            <Loader />
        </div>
    );
}
const SucessScreen = () => {
const navigate = useNavigate();
    return (
        <div className='flex items-center justify-start flex-col'>
            <h2 className='text-xl font-semibold'>Your Mock Interview is recorded sucessfully, you may check your result in few seconds</h2>
            <button onClick={()=>navigate('/mock')} className=" text-primary-color-900 hover:underline"> Back to mock page</button>
        </div>
    );
}
const Error = () => {

    return (
        <div className='flex items-center justify-start flex-col'>
            <h2 className='text-xl font-semibold'>Error</h2>
        </div>
    );
}


const InterviewScreen = ({ }) => {


    const { questionIndex, updateQuestionIndex, updateInterviewStatusToEnd } = useContext(MockInterviewContext);
    const questionNumber = questionIndex + 1;

    const currentMockId = (new URLSearchParams(window.location.search)).get('mock_id');
    const questionData = useSelector(store => store?.mocks?.[currentMockId]?.questions?.[questionIndex]);
    const noOfQuestions = useSelector(store => store?.mocks?.[currentMockId]?.questions?.length);

    const [interviewSubmiter, endInterview] = useRecordMock({
        currentMockId,
        questionNumber,
        onSucess: updateQuestionIndex,
        onInterviewEnd: updateInterviewStatusToEnd
    });

    // Question data from props
    const audioLink = questionData?.audio;
    const questionText = questionData?.question;


    // Audio handling
    const { current: audio } = useRef(new Audio(audioLink));
    audio.onerror = () => {
        // console.log("Error While loading the music") 
    };

    const [isPlaying, setIsPlaying] = useState(false);
    const [timeLeft, setTimeLeft] = useState(180);
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [showConfirmationPopup, setShowConfirmationPop] = useState(false);
    const timerRef = useRef(null);

    // Audio event listeners
    audio.addEventListener("pause", () => { setIsPlaying(false) });
    audio.addEventListener("play", () => { setIsPlaying(true) });

    // Functions
    const nextQuestion = async () => {
        setIsSubmitButtonClicked(true);
        audio.pause();
        interviewSubmiter();
    };

    const prevQuestion = () => {
        if (questionIndex > 0) {
            updateQuestionIndex(questionIndex - 1);
            stopRecording();
        }
    };
    const stopRecording = () => {
        setIsRecording(false);
    };

    // const restartTest = () => {
    //     updateQuestionIndex(0);
    //     stopRecording();
    // };

    const playQuestion = () => {
        audio.currentTime = 0;
        audio.play();
    };

    // Format seconds to mm:ss
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, "0")}:${secs
            .toString()
            .padStart(2, "0")}`;
    };

    // Timer for countdown
    useEffect(() => {
        const id = setInterval(() => {
            setTimeLeft(
                (pre) => {
                    if (pre === 1) {
                        nextQuestion();
                        clearInterval(id);
                    }
                    else {
                        return pre - 1;
                    }
                }
            )
        }, 1000);

        return () => { clearInterval(id); }
    }, []);

    // Timer for recording
    useEffect(() => {
        if (isRecording) {
            timerRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } else {
            clearInterval(timerRef.current);
        }

        return () => clearInterval(timerRef.current);
    }, [isRecording]);

    // Play audio on mount
    useEffect(() => {
        (() => !isPlaying && audio.play())();
        return () => isPlaying && audio.pause();
    }, []);


    return (<>

        {showConfirmationPopup && (
            <div className=' backdrop-blur-sm fixed bg-transparent h-screen w-full z-[999999] bg-[#F8F8F8] left-0 right-0 top-0 bottom-0  p-4 rounded-md flex items-center justify-center'>
                <div className=' bg-gray-100 p-4  max-w-96 rounded-md'>
                    <div className=' flex  flex-col justify-center items-center'>
                        <div className="flex w-full justify-end">
                            <img
                                onClick={() => setShowConfirmationPop(false)}
                                className=' cursor-pointer mb-2 w-8'
                                src={crossIcon}
                                alt="crossIcon" />
                        </div>


                        <div className=" flex flex-col items-center justify-center min-h-96">
                            <p className=" text-center">Are you sure, you want to submit the interview before attempting to answer all the questions? </p>
                            <div className="flex w-full gap-4 mt-4">
                                <button
                                    className=" flex-1 px-4 py-2 bg-[#FF5D0E] text-white rounded-lg hover:bg-orange-600"
                                    onClick={endInterview}
                                >
                                    Yes
                                </button>
                                <button
                                    className=" flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
                                    onClick={() => setShowConfirmationPop(false)}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}

        <div className="bg-gray-100 min-h-screen p-2 lg:p-8">
            <div className="w-full lg:w-[70vw] mx-auto bg-white rounded-lg p-6">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-3xl font-semibold text-gray-800"></h1>
                    {/* <h1 className="text-3xl font-semibold text-gray-800">Applied Jobs</h1> */}
                    <div className="flex gap-4">
                        <span className="text-lg font-semibold">Time Left: {timeLeft}s</span>

                    </div>
                </div>

                {/* Progress track */}
                <div className="flex items-center justify-between mb-8">
                    {Array.from({ length: noOfQuestions }).map((_, index) => (
                        <React.Fragment key={index}>
                            <div className={`rounded-full h-7 w-7 flex items-center justify-center transition-all duration-500 ${index <= questionIndex
                                ? 'bg-[#FF5D0E] border-4 border-[#FF5D0E] text-white scale-105'
                                : 'bg-white border-4 border-gray-300'
                                }`}>
                                {(index < questionIndex || index === questionIndex) && (
                                    <div className="w-4 h-4 rounded-full bg-white transition-all duration-300" />
                                )}
                            </div>
                            {index < noOfQuestions - 1 && (
                                <div className={`flex-1 h-1 transition-all duration-500 ease-in-out ${index < questionIndex ? 'bg-[#FF5D0E]' : 'bg-gray-300'
                                    }`}></div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* Question section */}
                <div className="mb-10">
                    <div className="flex items-center justify-between mb-8">
                        <div className="flex items-center gap-4">
                            <h2 className="text-xl text-gray-700">
                                # Question {questionNumber}
                            </h2>
                        </div>
                        <div className="flex justify-end">
                            <button
                                className="flex items-center gap-2 px-4 py-2 bg-[#FF5D0E] text-white rounded-full hover:bg-orange-600"
                                onClick={playQuestion}
                            >
                                <img src={playIcon} alt="Play" className="w-4 h-4" />
                                Replay Question
                            </button>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-8 rounded-lg mb-8">
                        <h3 className="text-3xl text-center font-normal text-gray-800">
                            {questionText}
                        </h3>
                        <div className="mt-4 flex justify-center">
                            <img
                                className="h-6 cursor-pointer"
                                title="volumeIcon"
                                src={volumeIcon}
                                onClick={isPlaying ? () => { audio.pause(); } : () => { audio.play(); }}
                            />
                        </div>
                    </div>

                    <div className="flex justify-between items-center px-4 flex-col lg:flex-row gap-4">
                        {/* {(noOfQuestions - 1 > questionIndex) ? (<button
                            className=' w-fit px-3 py-1 rounded-full bg-red-900 text-white flex items-center justify-center hover:bg-red-800'
                            onClick={() => setShowConfirmationPop(true)}
                        >
                            Submit Interview
                        </button>) : <span></span>} */}


                        <button
                            className="flex items-center gap-2 px-6 py-4 rounded-full bg-[#FF5D0E] cursor-default text-white"
                        >
                            <>
                                {/* Tap Here To Record */}
                                Recording in Progress
                                <svg
                                    className="w-5 h-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                                    />
                                </svg>
                            </>
                        </button>

                        <button
                            onClick={nextQuestion}
                            className="w-12 h-12 rounded-full bg-[#FF5D0E] text-white flex items-center justify-center hover:bg-orange-600"
                        >
                            <img src={arrow} alt="Next" className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>);
};

const Interview = () => {
    const { isInterviewCompleted, uploading, questionIndex } = useContext(MockInterviewContext);
    const currentMockId = (new URLSearchParams(window.location.search)).get('mock_id');
    const mockLoaded = useSelector(store => !!store?.mocks?.[currentMockId]?.questions?.length);

    if (isInterviewCompleted) return <SucessScreen />;
    if (!mockLoaded) return <Loader />;
    return uploading ? <Submiting /> : <InterviewScreen />;
}

export default Interview;